export default[
    {
        path: '/rubrica/cadastro',
        name: 'cadastro de rubricas', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/rubrica/lista',
        name: 'lista de rubricas', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/rubrica/editar/:id',
        name: 'editar rubricas', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]